/** A Shopify Markets locale path segment, e.g. `/en-ca` or `/fr`. */
const LOCALE_PATH_SEGMENT = /^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/)/i;

/**
 * Splits a Shopify Markets locale segment off the portal URL, e.g.
 * `/en-ca/apps/redo/returns-portal` → `en-ca` and `/apps/redo/returns-portal`.
 * The app proxy injects the unprefixed `base_path`, so the router only
 * matches once the segment is gone.
 */
export function stripLocalePathPrefix(
  pathname: string,
  basePath: string,
): { localeTag: string; pathname: string } | undefined {
  const base = basePath.replace(/\/$/, "");
  const match = LOCALE_PATH_SEGMENT.exec(pathname);
  if (!base || !match?.[1]) {
    return undefined;
  }
  const rest = pathname.slice(match[0].length);
  return rest === base || rest.startsWith(`${base}/`)
    ? { localeTag: match[1], pathname: rest }
    : undefined;
}
